module.exports = __webpack_public_path__ + "static/media/8990.fa122820.jpg";